import rem from '@nobia/zeus-components/lib/styled/rem'
import {
  createGlobalStyle,
  sanitize,
  theme,
  prop,
} from '@nobia/zeus-components/lib/styled'

import fonts from './fonts'

const fontSize = props => {
  const baseFont = theme('font.baseFontSize')(props)
  const remSize = rem(baseFont)(props)
  return remSize
}

export default createGlobalStyle`
  ${fonts}
  ${sanitize};

  * {
    box-sizing: border-box;
  }

  :root {
    font-weight: 300;
    line-height: 1.5;
  }

  body {
    padding: 0;
    font-size: ${fontSize};
    background-color: ${p => p.theme.body.bgColor};
    color: ${p => p.theme.body.color};
    font-family: ${prop('theme.font.paragraph.fontFamily')};
  }

  button {
    background-color: transparent;
    cursor: pointer;
    border: 0;
    font-family: inherit;
  }

  h1, h2, h3 {
    font-family: ${prop('theme.font.headings.fontFamily')};
    font-weight: ${prop('theme.font.headings.fontWeight')};
  }

  h2 {
    font-size: 23px;
    line-height: 28px;
    @media (min-width: ${prop('theme.body.tabletWidth')}) {
      font-size: 36px;
      line-height: 40px;
    }
  }

  h3 {
    font-size: 21px;
    line-height: 26px;
    @media (min-width: ${prop('theme.body.tabletWidth')}) {
      font-size: 28px;
      line-height: 35px;
    }
  }

  h4 {
    font-size: 16px;
    line-height: 22px;
    @media (min-width: ${prop('theme.body.tabletWidth')}) {
      font-size: 21px;
      line-height: 26px;
    }
  }

`
